// import AOS from 'aos';
import { throttle, debounce } from 'underscore'; //https://underscorejs.org
// import 'slick-carousel/slick/slick.min.js';

import Swiper from 'swiper/bundle';

// typical import
import gsap from "gsap";
import imagesLoaded from 'imagesloaded';

// get other plugins:
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


import Collapse from 'bootstrap/js/dist/collapse';


// custom jquery below
jQuery(document).ready(function ($) {
    'use strict';

    var body = document.querySelector('body');
    const header = document.querySelector("header#masthead");
    const main = document.querySelector("main");
    var headerHeight = "";


    window.addEventListener("load", function() {
        var headerHeight = header.offsetHeight;
        main.style.paddingTop = headerHeight + "px";
    });

    window.addEventListener("resize", function() {
        var headerHeight = header.offsetHeight;
        main.style.paddingTop = headerHeight + "px";
    });

    const links = gsap.utils.toArray(".menu a");
    const sections = gsap.utils.toArray(".anchor-target");


    // MOBILE NAV
    const mobileNav = document.getElementById('mobile-menu');
    const mobileToggle = document.getElementById('menu-toggle');

    mobileNav.style.display = 'none';

    mobileToggle.addEventListener("click", function(event) {
        event.preventDefault();

        if( this.classList.contains('clicked') ) {
            this.classList.remove('clicked');
            gsap.to(mobileNav, {duration: .2, autoAlpha: 0, display:"none"});
            body.classList.remove('mobile-menu-open');
        } else {
            this.classList.add('clicked');
            gsap.to(mobileNav, {duration: .2, display:"block", autoAlpha: 1});
            body.classList.add('mobile-menu-open');
        }
    });

    // Video Embeds
    const iframes = document.getElementsByTagName('iframe');

    for (let i = 0; i < iframes.length; i++) {
        const responsiveWrapper = document.createElement('div');
        const src = iframes[i].src;
        if (src.includes('youtube.com') || src.includes('vimeo.com')) {
            iframes[i].parentNode.insertBefore(responsiveWrapper, iframes[i]);
            responsiveWrapper.appendChild(iframes[i]);
            responsiveWrapper.classList.add('ratio', 'ratio-16x9');
        }
    }

    // Home Page Functions

    // Home Page Hero Video
    const homeHeroIframe = document.getElementById('home-hero-video');
    if( homeHeroIframe ) {

        const setVimeoSrc = function() {
            let vimeoSrc = '';

            if ( window.innerWidth < 768 ) {
                vimeoSrc = homeHeroIframe.getAttribute('data-src');
            } else {
                vimeoSrc = homeHeroIframe.getAttribute('data-desktop-src');
            }

            if( homeHeroIframe.hasAttribute("src") ) {
                const iframeSrc = homeHeroIframe.getAttribute('src');

                if( iframeSrc === vimeoSrc ) {

                } else {
                    homeHeroIframe.setAttribute('src', vimeoSrc);
                    setTimeout(function() {
                        playHomeHeroVideo();
                    }, 250);
                }

            } else {
                homeHeroIframe.setAttribute('src', vimeoSrc);
                setTimeout(function() {
                    playHomeHeroVideo();
                }, 250);
            }

        }

        const reSetVimeoSrc = function() {
            let vimeoSrc = '';

            if ( window.innerWidth < 768 ) {
                vimeoSrc = homeHeroIframe.getAttribute('data-src');
            } else {
                vimeoSrc = homeHeroIframe.getAttribute('data-desktop-src');
            }

            if( homeHeroIframe.hasAttribute("src") ) {
                const iframeSrc = homeHeroIframe.getAttribute('src');

                if( iframeSrc === vimeoSrc ) {

                } else {
                    homeHeroIframe.setAttribute('src', vimeoSrc);
                    setTimeout(function() {
                        playHomeHeroVideo();
                    }, 1000);
                }

            } else {
                homeHeroIframe.setAttribute('src', vimeoSrc);
                setTimeout(function() {
                    playHomeHeroVideo();
                }, 1000);
            }

        }

        window.addEventListener('load', setVimeoSrc);
        window.addEventListener('resize', reSetVimeoSrc);

        let playHomeHeroVideo = '';

        const setVimeoPlayer = async function() {

            const homeHeroPlayer = new Vimeo.Player(homeHeroIframe);
            const homeHeroProgressBar = document.getElementById('home-hero-progress-bar');

            const heroVideoBtn = document.getElementById('hero-video-click-play');
            const heroVideoCover = document.querySelectorAll('.hero-video-cover');
            const heroVideoWrap = document.querySelector('.video-hero');
            const heroVideo = document.querySelector('.video-hero iframe');

            const hhvPause = document.getElementById('hhv-pause');
            const hhvAudio = document.getElementById('hhv-audio');
            const hhvFull = document.getElementById('hhv-full');

            playHomeHeroVideo = function() {
                heroVideoWrap.classList.add('playing');
                homeHeroPlayer.play();
                hhvPause.classList.remove('clicked');

                homeHeroPlayer.getDuration().then(function(duration) {
                    homeHeroPlayer.on("timeupdate", function (data) {
                        homeHeroProgressBar.style.width = (data.percent * 100) + "%";
                    });
                });
            }

            const pauseHomeHeroVideo = function() {
                heroVideoWrap.classList.remove('playing');
                hhvPause.classList.add('clicked');
                homeHeroPlayer.pause();
            }

            const muteHomeHeroVideo = function() {
                hhvAudio.classList.remove('clicked');
                homeHeroPlayer.setVolume(0);
            }

            const unmuteHomeHeroVideo = function() {
                hhvAudio.classList.add('clicked');
                homeHeroPlayer.setVolume(1);
            }


            hhvPause.addEventListener("click", function() {
                if( this.classList.contains('clicked') ) {
                    playHomeHeroVideo();
                } else {
                    pauseHomeHeroVideo();
                }
            });

            hhvAudio.addEventListener("click", function() {
                if( this.classList.contains('clicked') ) {
                    muteHomeHeroVideo();
                } else {
                    unmuteHomeHeroVideo();
                }
            });

            hhvFull.addEventListener("click", function() {
                if (homeHeroPlayer.requestFullscreen) {
                    homeHeroPlayer.requestFullscreen();
                } else if (vimeoPlayer.mozRequestFullScreen) {
                    homeHeroPlayer.mozRequestFullScreen();
                } else if (vimeoPlayer.webkitRequestFullscreen) {
                   homeHeroPlayer.webkitRequestFullscreen();
                }
            });

            homeHeroPlayer.on('ended', function(data) {
                homeHeroPlayer.play();
                // hhvPause.classList.add('clicked', 'restart');
            });

            ScrollTrigger.create({
              trigger: ".video-hero",
              start: "bottom top+=90px",
              onLeave: muteHomeHeroVideo,
            });

        }

        window.addEventListener('load', setVimeoPlayer);

    }

    // Hero Paralax
    const hero = document.querySelector('.page-hero');
    if(hero) {

        const heroInner = document.querySelector(".page-hero .inner");

        if(heroInner) {
            imagesLoaded( document.querySelector('main'), function( instance ) {

                gsap.to(heroInner, {
                    yPercent: 200,
                    ease: "none",
                    overwrite: "all",
                    scrollTrigger: {
                        trigger: 'main',
                        start: "top top",
                        end: "bottom top",
                        scrub: true,
                    }
                });

            });
        }

    }

    // Hero Parallax
    const parallax = document.querySelectorAll('.parallax');
    if(parallax) {
        imagesLoaded( document.querySelector('main'), function( instance ) {
            parallax.forEach(element => {
                const parallaxInner = element.querySelector(".parallax .inner");
                if(parallaxInner) {
                    gsap.to(element, {
                        yPercent: 20,
                        ease: "none",
                        overwrite: "all",
                        scrollTrigger: {
                            trigger: parallaxInner,
                            start: "top top",
                            end: "bottom top",
                            scrub: true,
                        }
                    });
                }
            });
        });

    }


    // Fade in up
    const fadeInUpElements = document.querySelectorAll('.fade-in-up');
    if( fadeInUpElements ) {
        imagesLoaded( document.querySelector('main'), function( instance ) {
            fadeInUpElements.forEach(element => {
                const trigger = gsap.to(element, {
                    scrollTrigger: {
                        trigger: element,
                        start: 'bottom bottom+=100px',
                        onToggle: function() {
                            element.classList.add('active');
                        }
                    }
                });
            });
        });
    }


    // Fading from dusk bg to tape bg
    const bgttdElements = document.querySelectorAll('.bg-color-change');

    if (bgttdElements) {
        bgttdElements.forEach(element => {
            const trigger = gsap.to(element, {
                scrollTrigger: {
                    trigger: element,
                    start: 'top 50%',
                    onToggle: function() {
                        element.classList.toggle('active');
                    }
                }
            });
        });
    }


    // Fade In Up - Scrubbed
    const fadeInUpElementsScrubbed = document.querySelectorAll('.fade-in-up-scrub');
    if (fadeInUpElementsScrubbed) {
        fadeInUpElementsScrubbed.forEach(element => {
            gsap.set(element, { autoAlpha: 0, y: 100 });
            gsap.to(element, {
                autoAlpha: 1,
                y: 0,
                scrollTrigger: {
                    trigger: element,
                    start: "top 75%",
                    end: "top 50%",
                    scrub: true,
                }
            });
        });
    }

    // Fade In Up for .5 opacity elements
    const fadeInUpFromHalfElements = document.querySelectorAll('.fade-in-up-scrub-half-opacity');
    if(fadeInUpFromHalfElements) {
        fadeInUpFromHalfElements.forEach(element => {
            gsap.set(element, { autoAlpha: 0, y: 40 });
            gsap.to(element, {
                autoAlpha: .5,
                y: 0,
                scrollTrigger: {
                    trigger: element,
                    start: "bottom bottom+=50px",
                    end: "top 50%",
                    scrub: true,
                }
            });
        });
    }


    // Un-blur images on scroll
    const scollBlurElements = document.querySelectorAll('.scroll-blur');
    if(scollBlurElements) {
        imagesLoaded( document.querySelector('main'), function( instance ) {

            const blurImg = function() {
                if (window.innerWidth > 900 ) {
                    scollBlurElements.forEach(element => {
                        gsap.set(element, { filter: "blur(10px)" });
                        gsap.to(element, {
                            filter: "blur(0px)",
                            scrollTrigger: {
                                trigger: element,
                                start: "center bottom",
                                end: "top 40%",
                                scrub: true,
                            }
                        });
                    });
                }
            }

            blurImg();

            window.onresize = blurImg;

        });
    }


    // Region Clocks

    if(document.querySelectorAll('.s10 .region-clock-name').length ) {
        const regionClocks = document.querySelectorAll('.s10 .region-clock-name');
        const clocks = gsap.timeline({
            scrollTrigger: {
                trigger: ".s10 .rcn-wrap",
                start: "top 80%",
            }
        });
        clocks.from('.s10 img.object-fit-cover', {duration: .5, ease: "power1", autoAlpha: 0})
        .from(regionClocks, {duration: .5, ease: "back.out(1.7)", y:30, autoAlpha: 0, stagger: 0.15});
    }


    // Soccer Properties Slider
    const numSPSlides = document.querySelectorAll('.sp-slider-text .swiper-slide').length;
    if ( numSPSlides > 1 ) {
        const spSliderImg = new Swiper(".sp-slider-img", {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            loopAdditionalSlides: numSPSlides,
            effect: 'fade',
                fadeEffect: {
                crossFade: true
            },
        });
        const spSliderText = new Swiper(".sp-slider-text", {
            slidesPerView: 1,
            spaceBetween: 0,
            slideToClickedSlide: true,
            loop: true,
            loopAdditionalSlides: numSPSlides,
            pagination: {
                el: '.sp-text-swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: ".sp-swiper-button-next",
                prevEl: ".sp-swiper-button-prev",
            },
        });
        spSliderImg.controller.control = spSliderText;
        spSliderText.controller.control = spSliderImg;
    }


    // Integrated Marketing Services Slider
    const numIMSSlides = document.querySelectorAll('.ims-slider-text .swiper-slide').length;
    if ( numIMSSlides > 1 ) {
        const imsSliderImg = new Swiper(".ims-slider-img", {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            loopAdditionalSlides: numIMSSlides,
            effect: 'fade',
                fadeEffect: {
                crossFade: true
            },
        });
        const imsSliderText = new Swiper(".ims-slider-text", {
            slidesPerView: 1,
            spaceBetween: 0,
            slideToClickedSlide: true,
            loop: true,
            loopAdditionalSlides: numIMSSlides,
            pagination: {
                el: '.ims-text-swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: ".ims-swiper-button-next",
                prevEl: ".ims-swiper-button-prev",
            },
        });
        imsSliderImg.controller.control = imsSliderText;
        imsSliderText.controller.control = imsSliderImg;
    }

    // Desktop Logos Slider
    const numDesktopLogosSlides = document.querySelectorAll('.desktop-logos-slider .swiper-slide').length;
    if ( numDesktopLogosSlides > 1 ) {

        let logosSwiper = null;

        function initLogosSwiper() {
            let logosSwiper = new Swiper(".desktop-logos-slider", {
                slidesPerView: 2,
                spaceBetween: 20,
                freeMode: true,
                grabCursor: true,
                scrollbar: {
                    el: ".desktop-logos-swiper-scrollbar",
                    hide: false,
                    draggable: true,
                    grabCursor: true,
                },
                breakpoints: {
                  640: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                  768: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                  },
                  1024: {
                    slidesPerView: 5,
                    spaceBetween: 60,
                  },
                },
            });

            const desktopLogosliderScrollbar = document.querySelector(".desktop-logos-swiper-scrollbar > div");

            desktopLogosliderScrollbar.addEventListener("mousedown", function() {
              desktopLogosliderScrollbar.style.cursor = "grabbing";
            });

            desktopLogosliderScrollbar.addEventListener("mouseup", function() {
              desktopLogosliderScrollbar.style.cursor = "grab";
            });

        }

        // Check the window width and initialize/destroy the Swiper instance
        const mediaQuery = window.matchMedia('(min-width: 640px)');
        function handleMediaQuery() {
            if (mediaQuery.matches) {
                // Window width is more than 640px, initialize the Swiper instance
                if (!logosSwiper) {
                    initLogosSwiper();
                }
            } else {
                // Window width is less than or equal to 640px, destroy the Swiper instance
                if (logosSwiper) {
                    logosSwiper.destroy();
                    logosSwiper = null;
                }
            }
        }

        // Initialize/destroy the Swiper instance on page load and window resize
        handleMediaQuery(); // Initialize/destroy the Swiper instance on page load
        window.addEventListener('resize', handleMediaQuery); // Initialize/destroy the Swiper instance on window resize

    }

    // Case Studies Slider
    const caseStudySlides = document.querySelectorAll('.case-studies-slider .swiper-slide').length;
    if ( caseStudySlides > 1 ) {
        const caseStudiesSwiper = new Swiper(".case-studies-slider", {
            slidesPerView: 1,
            spaceBetween: 1,
            loop: true,
            navigation: {
                nextEl: ".cs-swiper-button-next",
                prevEl: ".cs-swiper-button-prev",
            },
            effect: 'fade',
                fadeEffect: {
                crossFade: true
            },
        });
    }

    // Case Study Post Slider
    const caseStudyPostSlides = document.querySelectorAll('.cs-post-slider .swiper-slide').length;
    if ( caseStudyPostSlides > 1 ) {
        const caseStudiesSwiper = new Swiper(".cs-post-slider", {
            slidesPerView: 1,
            spaceBetween: 16,
            loopAdditionalSlides: caseStudyPostSlides,
            loop: true,
            navigation: {
                nextEl: ".cs-swiper-button-next",
                prevEl: ".cs-swiper-button-prev",
            },
            pagination: {
                el: '.cs-post-swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
              768: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
            },
        });

        const ccpsPagination = document.querySelector('.cs-post-swiper-pagination');
        const ccpsFigCaptions = document.querySelectorAll('.cs-post-slider .swiper-slide figcaption');

        // Get the tallest element including padding
        const findCCPSCaptionHeight = function() {
            let maxHeight = 0;

            for (let i = 0; i < ccpsFigCaptions.length; i++) {
              let ccpsFigCaption = ccpsFigCaptions[i];
              let height = ccpsFigCaption.offsetHeight + parseInt(getComputedStyle(ccpsFigCaption).paddingTop) + parseInt(getComputedStyle(ccpsFigCaption).paddingBottom);
              if (height > maxHeight) {
                maxHeight = height;
              }
            }
            ccpsPagination.style.bottom = maxHeight+'px';
            ccpsPagination.style.opacity = 1;
        }

        window.addEventListener('load', findCCPSCaptionHeight);
        window.addEventListener('resize', findCCPSCaptionHeight);

    }



    // Properties Slider
    const propertiesSlides = document.querySelectorAll('.properties-slider .swiper-slide').length;
    if ( propertiesSlides > 1 ) {
        const propertiesSwiper = new Swiper(".properties-slider", {
            slidesPerView: 1,
            spaceBetween: 1,
            allowTouchMove: false,
            clickable: false,
            pagination: {
                el: '.properties-swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: false,
                    translate: [0, 0, -400],
                    opacity: 0,
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
        });


        const propertySlidesBtns = document.querySelectorAll('.properties-pagination-wrap a');

        propertySlidesBtns.forEach(btn => {
            btn.addEventListener('click', function(event){
                event.preventDefault();

                var index = Array.prototype.indexOf.call(propertySlidesBtns, event.target);

                btn.classList.add('clicked');

                propertiesSwiper.slideTo(index, 1200, false);

                const activeEl = document.querySelector('.properties-pagination-wrap a.clicked');
                if (activeEl) {
                    activeEl.classList.remove('active');
                }

            });
        });

        // Property Post Slider
        const propertyPostSlides = document.querySelectorAll('.property-post-slider .swiper-slide').length;
        if ( propertyPostSlides > 1 ) {

            const propertyPostSlider = new Swiper(".property-post-slider .swiper-container", {
                slidesPerView: 1,
                spaceBetween: 1,
                grabCursor: true,
                loopAdditionalSlides: propertyPostSlides,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                pagination: {
                    el: '.pp-swiper-pagination',
                    clickable: true
                },

            });


            $(".property-post-slider .swiper-container").each(function(index, element){
                const swiper = this.swiper;
                const ppsParent = this.closest('.single-property-post');
                swiper.update();
                swiper.autoplay.stop();

                const playPPSwiper = function() {
                    const activeSlideIndex = propertiesSwiper.realIndex;
                    const activeSlide = propertiesSwiper.slides[activeSlideIndex];

                    if( ppsParent === activeSlide) {
                        swiper.autoplay.start();
                    } else {
                        swiper.autoplay.stop();
                    }
                }

                playPPSwiper();

                propertiesSwiper.on('afterInit, slideChange', function () {
                    playPPSwiper();
                });

            });

        }


    }






    // Insights Page Functions
    if( body.classList.contains('page-template-insights-page') || body.classList.contains('page-template-work-page') ) {

        const filterDropdownToggle = document.getElementById('cat-dropdown-toggle');
        const catFilter = document.getElementById('cat-filter');
        const catFilterBtns = document.querySelectorAll('.cat-filter-btn');

        if( body.classList.contains('page-template-insights-page') ) {
            // Show/hide Post Category Filter
            filterDropdownToggle.onclick = function(event) {
                event.preventDefault();
                catFilter.classList.toggle('open');
            }
        }

    /**
         * ALM Filter button click event.
         *
         * @param {*} event
         */
        function filterClick(event) {
            event.preventDefault();

            // Exit if button active.
            if (this.classList.contains('active')) {
                return;
            }

            // Get .active element.
            const activeEl = document.querySelector('.alm-filter-nav button.active');
            if (activeEl) {
                activeEl.classList.remove('active');
            }

            // Add active class.
            this.classList.add('active');

            // Set filter params
            const transition = 'fade';
            const speed = 250;
            const data = this.dataset;

            const activePostType = data['postType'];
            const taxonomyOperator = data['taxonomyOperator'];
            const catFilter = document.getElementById('cat-filter');
            const postFilter  = document.getElementById('post-filter');

            if( body.classList.contains('page-template-insights-page') ) {

                // Close Category Filter when a Term is selected
                catFilterBtns.forEach(btn => {
                    btn.addEventListener('click', function(){
                        catFilter.classList.remove('open');
                    });
                });

                // Filter News & Insights
                const newsBtn = document.getElementById('news-filter-btn');
                const insightsBtn = document.getElementById('insights-filter-btn');

                if( activePostType === 'news' ) {
                    catFilter.classList.remove('hide');
                    newsBtn.classList.add('active-type');
                } else {
                    catFilter.classList.add('hide');
                    newsBtn.classList.remove('active-type');
                }

                if( activePostType === 'insights' ) {
                    insightsBtn.classList.add('active-type');
                } else {
                    insightsBtn.classList.remove('active-type');
                }

            }

            if( taxonomyOperator === 'IN' ) {
                postFilter.classList.add('term-filtered');
            } else {
                postFilter.classList.remove('term-filtered');
            }

            // Call core Ajax Load More `filter` function.
            // @see https://connekthq.com/plugins/ajax-load-more/docs/public-functions/#filter
            ajaxloadmore.filter(transition, speed, data);
        }

        // Get all filter buttons.
        const filter_buttons = document.querySelectorAll('.alm-filter-nav button:not(#cat-dropdown-toggle)');

        if (filter_buttons) {
            // Set initial active item.
            filter_buttons[0].classList.add('active');

            // Loop buttons.
            [].forEach.call(filter_buttons, function (button) {
                // Add button click event.
                button.addEventListener('click', filterClick);
            });
        }

        window.almComplete = function(alm){

        };

    }

    // animate on scroll init - https://michalsnik.github.io/aos/
    // ** IF USING SLICK SLIDER, AOS MUST BE INITIALIZED AFTER ANY/ALL SLICK SLIDERS **
    // AOS.init({
    //     offset: 200
    // });

});
